import React from 'react';

import { graphql, useFragment } from 'react-relay';

import Image from '@atlaskit/image';
import Tooltip from '@atlaskit/tooltip';

import type { JiraIssueTypeIcon_Platform$key } from './__generated__/JiraIssueTypeIcon_Platform.graphql';

export type Props = {
	issueType: JiraIssueTypeIcon_Platform$key;
	showTooltip?: boolean;
};

export const JiraIssueTypeIcon = ({ issueType, showTooltip }: Props): React.JSX.Element => {
	const data = useFragment<JiraIssueTypeIcon_Platform$key>(
		graphql`
			fragment JiraIssueTypeIcon_Platform on JiraIssueType {
				name
				avatar {
					small
				}
			}
		`,
		issueType,
	);

	const name = data.name;
	const avatarUrl = data.avatar?.small;

	const image = <Image src={avatarUrl ?? undefined} alt={name} width={16} />;

	if (showTooltip) {
		return (
			<Tooltip position="top" content={name}>
				{image}
			</Tooltip>
		);
	}

	return image;
};
